export default "<div *ngIf=\"task\">\n <app-equation [data]=\"equation\"></app-equation>\n</div>"